import { render, staticRenderFns } from "./BearbeiteKunde.vue?vue&type=template&id=15f123de&"
import script from "./BearbeiteKunde.vue?vue&type=script&lang=js&"
export * from "./BearbeiteKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports